import * as fetchProfile from 'store/actions/users/fetchProfile';
import * as types from 'store/actions/types';
import * as updateProfile from 'store/actions/users/updateProfile';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import utils from 'helpers/utils';
import { put, takeLatest } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchProfileAsync(payload) {
    const {
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/@me/profile`;

        const response = yield apiClient.read(url);

        yield put(fetchProfile.fetchProfileSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(fetchProfile.fetchProfileFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* updateProfileAsync({ payload }) {
    const {
        callback,
        formValues,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/@me/profile`;

        const response = yield apiClient.patch(url, formValues);

        yield put(updateProfile.updateProfileSuccess(response));

        yield callback();
    } catch (error) {
        yield put(updateProfile.updateProfileFailure(error));

        yield callback(error);
    }
}

function* updateProfileSuccessAsync() {
    yield put(showNotification('notifications.profile.update.success'));
}

function* updateProfilePasswordAsync({ payload }) {
    const {
        callback,
        formValues,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/@me/password`;

        const response = yield apiClient.patch(url, formValues);

        yield put(updateProfile.updateProfilePasswordSuccess(response));

        yield callback();
    } catch (error) {
        yield put(updateProfile.updateProfilePasswordFailure(error));

        yield callback(error);
    }
}

function* updateProfilePasswordSuccessAsync() {
    yield put(showNotification('notifications.profile.update.success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* profileSagas() {
    yield [
        takeLatest(types.FETCH_PROFILE, fetchProfileAsync),
        takeLatest(types.FETCH_PROFILE_FAILURE, failureMessage),

        takeLatest(types.UPDATE_PROFILE, updateProfileAsync),
        takeLatest(types.UPDATE_PROFILE_FAILURE, failureMessage),
        takeLatest(types.UPDATE_PROFILE_SUCCESS, updateProfileSuccessAsync),

        takeLatest(types.UPDATE_PROFILE_PASSWORD, updateProfilePasswordAsync),
        takeLatest(types.UPDATE_PROFILE_PASSWORD_FAILURE, failureMessage),
        takeLatest(types.UPDATE_PROFILE_PASSWORD_SUCCESS, updateProfilePasswordSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/profileSagas.js